import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PromocionesService } from '../../services/promociones.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { LfsaBotonsGridComponent } from 'src/app/shared/components/lfsa-botons-grid/lfsa-botons-grid.component';

@Component({
  selector: 'app-promocion-grupos',
  templateUrl: './promocion-grupos.component.html',
  styleUrls: ['./promocion-grupos.component.css']
})
export class PromocionGruposComponent implements OnInit {

  gridApi: any;
  gridColumnApi: any;
  columnDefsGrupo = [];
  frameworkComponents: any;
  rowDataGrupo: any[] = [];
  verFormularioAgregarGrupo = false;

  grupo?: any;
  idPromo: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly promocionesService: PromocionesService,
    private readonly _util: UtilsService
  ) {
    this.gridComponent();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'] as string
      if (id) {
        this.idPromo = id;
        this.cargarGrupo(id);
      }
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      iconButtonRenderer: LfsaBotonsGridComponent
    };

    this.columnDefsGrupo = [
      {
        headerName: 'Grupo',
        field: 'id_grupo',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Descripción',
        field: 'dsca_grupo',
        sortable: true,
        filter: true
      },
      {
        headerName: 'Cantidad',
        field: 'cantidad',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        cellRendererParams: {
          onClick: this.editarGrupo.bind(this),
          label: 'Editar',
          colorBoton: 'btn btn-info btn-block',
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 60,
        cellRendererParams: {
          onClick: this.eliminarGrupo.bind(this),
          label: 'Eliminar',
          colorBoton: 'btn btn-danger btn-block',
        },
      },
    ];
  }

  cargarGrupo(id_promo) {
    this.promocionesService.cargarGrupo(id_promo.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.rowDataGrupo = resp;
        } else {
          this.rowDataGrupo = [];
        }
      },
      (error) => {
        this.rowDataGrupo = [];
      }
    );
  }

  nuevoGrupo() {
    this.grupo = undefined;
    this.verFormularioAgregarGrupo = true;
  }

  editarGrupo({ rowData }) {
    this.grupo = rowData;
    this.verFormularioAgregarGrupo = true;
  }

  back() {
    this.verFormularioAgregarGrupo = false;
  }

  guardarGrupo(payload: any) {
    payload.cantidad = payload.cantidad ? parseFloat(payload.cantidad) : null;

    this._util
      .confirmarSincronoPromesa({
        title: '¿Esta seguro que desea procesar el siguiente formulario?',
        action: this.grupo ? 'Editar' : 'Nuevo',
        funcion: this.promocionesService.crearGrupo(payload),
      })
      .then((res: any) => {
        this.cargarGrupo(this.idPromo);
        this.verFormularioAgregarGrupo = false;
      });
  }

  eliminarGrupo({ rowData }) {
    this._util
      .confirmarSincronoPromesa({
        title: 'Eliminar',
        // text: `ID PROMO: ${rowData.id_promo}`,
        action: 'Eliminar',
        funcion: this.promocionesService.borrarGrupo(rowData),
      })
      .then((res: any) => {
        this.cargarGrupo(this.idPromo);
      });
  }

}
